/* recovered from production bundle — App.tsx */
// @ts-nocheck

import React, { Suspense, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getToken } from './lib/auth';
import { appConfig, isLiteEdition } from './lib/config';
import { LoginPage } from './components/auth/LoginPage';
import { ErrorBoundary } from './components/ui/ErrorBoundary';
import { useSchedulerHeartbeat } from './hooks/useSchedulerHeartbeat';
import { installTouchContextBridge } from './lib/touch-context-bridge';
import './i18n';

const MainLayout = React.lazy(() =>
  import('./features/bundle.jsx').then((m) => ({ default: m.MainLayout })),
);

export function App() {
  const { t, i18n } = useTranslation('common');
  const [e, setAuthed] = React.useState(() => {
    try { return !!getToken(); } catch (_) { return false; }
  });
  React.useEffect(() => {
    try { document.title = appConfig.appTitle; } catch (_) {}
    try { document.documentElement.lang = i18n.language || 'en'; } catch (_) {}
    installTouchContextBridge();
  }, [i18n.language]);
  React.useEffect(() => {
    const n = () => { try { setAuthed(!!getToken()); } catch (_) {} };
    window.addEventListener('storage', n);
    return () => window.removeEventListener('storage', n);
  }, []);
  useSchedulerHeartbeat(!isLiteEdition);
  if (e) {
    return (
      <ErrorBoundary>
        <Suspense fallback={<div className="h-screen flex items-center justify-center text-nv-textMuted text-sm">{t('loading')}</div>}>
          <MainLayout onLogout={() => setAuthed(false)} />
        </Suspense>
      </ErrorBoundary>
    );
  }
  return (
    <ErrorBoundary>
      <LoginPage onLogin={() => setAuthed(true)} />
    </ErrorBoundary>
  );
}
